module.exports = __webpack_public_path__ + "img/message.9e0fc38f.png";